import { DatasetSkeletonCard } from "@/features/dataset";
import { Flex } from "@mantine/core";

export function DiscoverResultsLoading({ count }: { count: number }) {
  return (
    <Flex direction="column" p={5} gap="md">
      {Array.from({ length: count }).map((_, index) => (
        <DatasetSkeletonCard key={index} />
      ))}
    </Flex>
  );
}
